<template>
	<!-- 扫码手机体验 -->
	<div class="create-code look-wap qjc-absolute qjc-clearfix">
		<div v-if="isCreateCode" class="code qjc-fl">
			<vue-qr class="code-img" :text="codeUrl" :logoSrc="require('@/assets/images/code_logo.png')" :margin="5" :correctLevel="3"></vue-qr>
		</div>
		<div v-else class="text qjc-fl">
			<span @click="createCode" class="qjc-fts-28">{{ language === 'HK'?'掃碼手機體驗':'Scan QR code for mobile experience' }}</span>
		</div>
		<img @click="createCode" class="qjc-fl" :src="require('@/assets/images/lookatwap.' + (isCreateCode?'png':'gif'))" alt="扫码手机体验图">
	</div>
</template>

<script>
	import vueQr from 'vue-qr'
	
	export default{
		name: 'createCode',
		data() {
			return {
				isCreateCode: false,// 生成二维码
				codeUrl: '' // 二维码链接
			}
		},
		props: ['language'],
		components: {
			vueQr
		},
		methods: {
			// 生成二维码(只执行一次，后面定时器刷新)
			createCode() {
				if(!this.isCreateCode){
					this.isCreateCode = true;
					
					this.codeUrl = location.origin + '/' + this.$router.resolve({ 
						path: this.language?'/'+ this.language +'/m':'/m',
						query: {
							timestamp: new Date().getTime()/1000
						}
					}).href;
					
					setTimeout(() => {
						this.isCreateCode = false;
					}, 60 * 1000);
				}
						
			}
		}
	}
</script>

<style lang="scss" scoped>
	.look-wap{
		right: 0.33rem;
		bottom: 0.26rem;
		justify-content: space-around;
		align-items: center;
		color: #5FD6FF;
		font-weight: 400;
		
		.code{
			width: 1.04rem;
			height: 1.04rem;
			padding: 0.08rem;
			margin-top: 0.24rem;
			border: 0.01rem solid #5FD6FF;
			background-color: #1E4172;
			border-radius: 0.04rem;
			
			.code-img{
				width: 100%;
				height: 100%;
				margin: 0;
			}
		}
		
		.text{
			position: relative;
			height: 0.46rem;
			line-height: 0.46rem;
			text-align: center;
			margin-top: 0.61rem;
			background-color: #1E4172;
			border-radius: 1.12rem 1.12rem 0 1.12rem;
			border: 0.01rem solid #5FD6FF;
			overflow: hidden;
			animation: text 8s ease-in-out infinite;
			
			&::before{
				content: '';
				position: absolute;
				left: 0;
				top: 0;
				bottom: 0;
				width: 0.16rem;
				background-color: #1E4172;
				z-index: 20;
			}
			
			span{
				position: absolute;
				top: 0;
				right: 0;
				width: 5.16rem;
				z-index: 10;
			}
		}
		@keyframes text{
			0%{
				width: 0;
				border: none;
				border-radius: 0;
			}
			0.1%{
				border: 0.01rem solid #5FD6FF;
				border-radius: 0;
			}
			5%{
				border: 0.01rem solid #5FD6FF;
				border-radius: 0;
			}
			10%{
				border: 0.01rem solid #5FD6FF;
				border-radius: 1.12rem 1.12rem 0 1.12rem;
			}
			50%{
				width: 5.16rem;
				border: 0.01rem solid #5FD6FF;
				border-radius: 1.12rem 1.12rem 0 1.12rem;
			}
			55%{
				border: 0.01rem solid #5FD6FF;
				border-radius: 0;
			}
			59.9%{
				border: 0.01rem solid #5FD6FF;
				border-radius: 0;
			}
			60%{
				width: 0;
				border: none;
				border-radius: 0;
			}
			100%{
				width: 0;
				border: none;
				border-radius: 0;
			}
			
		}
		
		img{
			width: 0.95rem;
			height: 1.41rem;
			margin-left: 0.16rem;
		}
	}
</style>
